import {Provider} from "@angular/core";
import {CommonXhrBackend} from "./common.xhr.backend";
import {CommonErrorResolver} from "./common.error.resolver";
import {XHRBackend, BrowserXhr, ResponseOptions, XSRFStrategy} from "@angular/http";

export * from './error.response.i';
export * from './common.xhr.backend';
export * from './common.error.resolver';

export const COMMON_XHR_BACKEND_PROVIDERS: Provider[] = [
    {
        provide: XHRBackend,
        useFactory: (browser: BrowserXhr, options: ResponseOptions, strategy: XSRFStrategy, errorResolver: CommonErrorResolver) => {
            return new CommonXhrBackend(browser, options, strategy, errorResolver);
        },
        deps: [BrowserXhr, ResponseOptions, XSRFStrategy, CommonErrorResolver]
    }
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/providers/index.ts